export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.45.0-30c130124.svg#plus-filled","viewBox":"0 0 18 18"}